import { Component, Input } from '@angular/core';
/**ToDo Documentazione */
@Component({
  selector: 'app-overview',
  styleUrls: ['./overview.component.scss'],
  templateUrl: './overview.component.html'
})
export class OverviewComponent {
  @Input() public citiesImages: any;
  @Input() public days: any;
  @Input() public defaultImages: any = {};
  @Input() public iter: any;
  @Input() public lastUpdate: any;
  @Input() public noImageUrl: any;
  @Input() public passengers: any;
  @Input() public serviceIcons: any;
  @Input() public state: any;
  @Input() public urlCitiesImages = '';
  @Input() public version: any;
}
